export default __webpack_public_path__ + "static/media/up-arrow.ccfdeef4.svg";